import { render } from "./Journalist.vue?vue&type=template&id=b288d0e6&scoped=true"
import script from "./Journalist.vue?vue&type=script&lang=js"
export * from "./Journalist.vue?vue&type=script&lang=js"

import "./Journalist.vue?vue&type=style&index=0&id=b288d0e6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b288d0e6"]])

export default __exports__